/* eslint-disable @typescript-eslint/no-unsafe-argument */

export function isEmpty(value: any) {
  if (value == null) return true; // Verifica null ou undefined

  if (typeof value === 'string' && value.trim() === '') return true; // String vazia

  if (Array.isArray(value) && value.length === 0) return true; // Array vazio

  if (typeof value === 'object' && Object.keys(value as object).length === 0)
    return true; // Objeto vazio

  return false; // Não está vazio
}
export function areAllPropertiesEmpty(obj: object) {
  return Object.values(obj).every(isEmpty);
}

export function isObjectEmptyOrNull(obj: any): boolean {
  if (!obj || typeof obj !== 'object') return true;

  return Object.keys(obj).length === 0;
}
